import withReactContent, {ReactSweetAlertOptions} from "sweetalert2-react-content";
import Swal from "sweetalert2";
import React, {ChangeEvent, SyntheticEvent, useState} from "react";
import RenewalStore from "../../stores/renewal-store";
import {Autocomplete, Container, FormControlLabel, Radio, RadioGroup, TextField} from "@mui/material";
import ChangeFeinComponent from "./change-fein-component";
import AddressDetailsEditor from "./address-details-editor";
import {CompanyAddressDetails, getAddressCountry, normalizeAddressDetails} from "../../assets/address-details";
import {FortressDivider} from "../../components/fortress-divider";
import {feinError, mailingAddressError, officerError, principalAddressError, registeredAgentError, registeredAgentName} from '../../assets/company-review';

function editButtonAction({field, index, addressOnly = false, selectAgentType = false}: { field: string, index?: number, addressOnly?: boolean, selectAgentType?: boolean }) {
    // console.log("edit button action");
    let formState = {};
    // console.log(formState);
    const MySwal = withReactContent(Swal)

    const manageFormState = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>|SyntheticEvent, fieldName: string) => {
        // console.log("form state managed");
        if (fieldName === "fein") {
            switch ((event.target as HTMLInputElement).value) {
                case "applied":
                    formState = "Applied For"
                    break
                case "na":
                    formState = "Not Applicable"
                    break
                case "provided":
                    formState = ""
                    break
                default:
                    formState = (event.target as HTMLInputElement).value;
            }
        } else if(fieldName==="titleName") {
            formState[fieldName] = (event.target as HTMLInputElement).textContent;
        }else {
            formState[fieldName] = (event.target as HTMLInputElement).value;
        }
        console.log(formState);
        Swal.resetValidationMessage();
    }

    const validateForm = (data: { fieldName: string; errorMessage: string }[]) => {
        data.reverse().forEach((singleCell) => {
            if (singleCell.fieldName === "fein") {
                // "Applied For", "Not Applicable" or nine digits, as the server accepts; the editor needs a choice.
                const fein = formState == null ? "" : typeof formState === "string" ? formState : null;
                if (fein === null || fein.trim() === "" || feinError(fein)) {
                    Swal.showValidationMessage(singleCell.errorMessage);
                }
            } else {
                if (String(formState[singleCell.fieldName] ?? "").trim() === "") {
                    Swal.showValidationMessage(
                        singleCell.errorMessage
                    )
                }
            }

        })
    }

    if (field === "principal" || field === "mailing") {
        const addressField = field === "principal" ? "principalAddress" : "mailingAddress";
        let address: CompanyAddressDetails = {...(RenewalStore.getUpdatedCompanyInfo[addressField] || {})};
        const options: ReactSweetAlertOptions = {
            title: field === "principal" ? "Change Principal Address" : "Change Mailing Address",
            html: <AddressDetailsEditor initialAddress={address} onChange={(field, value) => {
                address = {...address, [field]: value};
                Swal.resetValidationMessage();
            }}/>,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Change",
            showCloseButton: true,
            preConfirm: () => {
                const error = field === "principal" ? principalAddressError(address) : mailingAddressError(address);
                if (error) {
                    Swal.showValidationMessage(error);
                    return false;
                }
                address = normalizeAddressDetails({...address, country: getAddressCountry(address)});
                return address;
            },
        };
        MySwal.fire(options).then(result => {
            if (result.isConfirmed) RenewalStore.replaceUpdatedCompanyInfoField(addressField, address);
        });
    }
    else if (field === "registered_agent") {
        const storedAgent = RenewalStore.getUpdatedCompanyInfo.registeredAgent ?? {};
        formState = JSON.parse(JSON.stringify(storedAgent));
        formState['state'] = 'FL';
        formState['country'] = 'US';
        const options: ReactSweetAlertOptions = {
            title: `Change Registered Agent`,
            html: <>
                <Container disableGutters sx={{}}>
                    {selectAgentType && <RadioGroup aria-label="Registered agent type" defaultValue={formState['type'] ?? ''}
                                                   onChange={event => manageFormState(event, 'type')} row>
                        <FormControlLabel value="P" control={<Radio/>} label="Individual"/>
                        <FormControlLabel value="C" control={<Radio/>} label="Business entity"/>
                    </RadioGroup>}
                    <TextField fullWidth label={'Name'} margin="normal" variant="outlined"
                               defaultValue={registeredAgentName(storedAgent)}
                               onChange={(event) => {
                                   manageFormState(event, 'firstName');
                                   formState['lastName'] = '';
                                   formState['middleName'] = '';
                                   formState['titleName'] = '';
                               }}/>
                    <TextField fullWidth label={'Address'} margin="normal" variant="outlined"
                               defaultValue={storedAgent.address ?? ""}
                               onChange={(event) => {
                                   manageFormState(event, 'address')
                               }}/>
                    <TextField fullWidth label={'City'} margin="normal" variant="outlined"
                               defaultValue={storedAgent.city ?? ""}
                               onChange={(event) => {
                                   manageFormState(event, 'city')
                               }}/>
                    <TextField fullWidth disabled label={'State'} margin="normal" variant="outlined"
                               value="FL" helperText="The registered agent must have a Florida address."/>
                    <TextField fullWidth label={'Zip Code'} margin="normal" variant="outlined"
                               defaultValue={storedAgent.zipCode ?? ""}
                               onChange={(event) => {
                                   manageFormState(event, 'zipCode')
                               }}/>
                </Container>
            </>,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Change",
            showCloseButton: true,
            preConfirm: () => {
                // Only an exact match of the agent's name to the company name is refused, as on the server.
                const error = registeredAgentError(formState, RenewalStore.getUpdatedCompanyInfo.name, {requireType: selectAgentType});
                if (error) {
                    Swal.showValidationMessage(error);
                    return false;
                }
                formState = normalizeAddressDetails(formState);
                return formState;
            },
        }
        return MySwal.fire(options).then((result) => {
            if (result.isConfirmed) {
                RenewalStore.replaceUpdatedCompanyInfoField('registeredAgent', formState);
            }

        });
    }
    else if (field.includes("officer")) {
        // formState = JSON.parse(JSON.stringify(RenewalStore.getUpdatedCompanyInfo[field]));
        if (RenewalStore.getUpdatedCompanyInfo.officers[index!] !== undefined) {
            formState = JSON.parse(JSON.stringify(RenewalStore.getUpdatedCompanyInfo.officers[index!]));
        }
        const options: ReactSweetAlertOptions = {
            title: Object.keys(formState).length === 0 ? `New Officer` : `Change Officer`,
            html: <>
                <Container disableGutters sx={{}}>
                    <FortressDivider textAlign="left">Officer Details</FortressDivider>
                    <TextField disabled={addressOnly} fullWidth label={'Title'} margin="normal" variant="outlined"
                               defaultValue={`${formState['title'] ?? ""}`}
                               onChange={(event) => {
                                   manageFormState(event, 'title')
                               }}/>
                    <TextField disabled={addressOnly} fullWidth label={'First Name'} margin="normal" variant="outlined"
                               defaultValue={`${formState['firstName'] ?? ""}`}
                               onChange={(event) => {
                                   manageFormState(event, 'firstName')
                               }}/>
                    <TextField disabled={addressOnly} fullWidth label={'Last Name'} margin="normal" variant="outlined"
                               defaultValue={`${formState['lastName'] ?? ""}`}
                               onChange={(event) => {
                                   manageFormState(event, 'lastName')
                               }}/>
                    <TextField disabled={addressOnly} fullWidth label={'Middle Initial'} margin="normal" variant="outlined"
                               defaultValue={`${formState['middleName'] ?? ""}`}
                               onChange={(event) => {
                                   manageFormState(event, 'middleName')
                               }}/>
                    <Autocomplete
                        disabled={addressOnly}
                        sx={{mt: 2, mb: 1,}}
                        freeSolo
                        disablePortal
                        id="combo-box-demo"
                        options={["Sr.", "Jr.", "II", "III", "IV", "Esq.", "Dr.", "Phd"]}
                        defaultValue={formState['titleName'] ?? ""}
                        renderInput={(params) => <TextField {...params} label="Title (Sr., Jr., etc.)"/>}
                        onInputChange={(_, value) => {
                            formState['titleName'] = value;
                            Swal.resetValidationMessage();
                        }}
                    />
                    <FortressDivider textAlign="left" sx={{mt: 3}}>Officer Address</FortressDivider>
                    <AddressDetailsEditor initialAddress={formState} singleLine onChange={(field, value) => {
                        formState[field] = value;
                        Swal.resetValidationMessage();
                    }}/>
                </Container>
            </>,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: Object.keys(formState).length === 0 ? "Add" : "Change",
            showCloseButton: true,
            preConfirm: () => {
                const error = officerError(formState);
                if (error) {
                    Swal.showValidationMessage(error);
                    return false;
                }
                formState = normalizeAddressDetails({...formState, country: getAddressCountry(formState)});
                return formState;
            },
        }
        MySwal.fire(options).then((result) => {
            if (result.isConfirmed) {
                console.log("replacing!");
                // RenewalStore.replaceUpdatedCompanyInfoField(field, formState);
                RenewalStore.replaceUpdatedCompanyInfoOfficer(index!, formState);
            }

        });
    }
    else if (field == "ein") {
        formState = RenewalStore.getUpdatedCompanyInfo.fein;
        console.log(formState);
        const options: ReactSweetAlertOptions = {
            title: `Change FEI/EIN Number`,
            html: <>
                <Container disableGutters sx={{}}>
                    <ChangeFeinComponent manageFormState={manageFormState}/>
                </Container>
            </>,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Change",
            showCloseButton: true,
            preConfirm: () => validateForm([
                {fieldName: 'fein', errorMessage: 'Please enter a valid EIN in format xx-xxxxxxx'},
            ]),
        }
        MySwal.fire(options).then((result) => {
            if (result.isConfirmed) {
                RenewalStore.replaceUpdatedCompanyInfoField('fein', formState);
            }

        });
    }
}

export default editButtonAction
